<template>
  <Navbar class="nav" />
  <div v-if="$root.loading" class="spinner-border ml-auto" role="status" aria-hidden="true">
  </div>
  <router-view/>
</template>

<script>
import router from './router'
import axios from 'axios'
import Navbar from './components/Navbar.vue'

export default {
  name: 'App',
  router,
  components:{
    Navbar
  },
  data(){
    return{
      loading: false,
      licentiate: {},
      sublicentiate: {},
      contract: {}, 
      products:[],
      act_date: '',
      token: '',
      user: {},
      document_number: '',
      invoice_id: '',
      is_date_edit: false,
      edit_date_access: true,
      error: false
    }
  },
  methods:{
    get_invoice_data(){
      if(this.$route.params.id == undefined){
        return false
      }
      this.loading = true;
      this.invoice_id = this.$route.params.id
      axios.defaults.headers.get['x-access-token'] = this.token
      axios.get('https://c.seldon.org/tenma/invoice/'+this.invoice_id).then((response) => {
      if(response.data['code'] == 400){
        this.error = true
        this.loading = false;
        return false
      }
      if(response.data['contract']['number'].length){
          this.contract = response.data.contract;
          this.licentiate = response.data.licentiate;
          this.sublicentiate = response.data.sublicentiate;
          this.products = response.data.products;

          this.licentiate.regulation = 'действующего на основании Устава,'
          if(this.isIp){
            this.licentiate.regulation = ''
          }

          this.sublicentiate.regulation = 'действующего на основании Устава,'
          if(this.isIp){
            this.sublicentiate.regulation = ''
          }
          
          self = this
          response.data.products.forEach(function(item, i, arr) {

            self.products[i]["license_price"] = item["license_price"].toFixed(2)
            self.products[i]["license_total_sum"] = item["license_total_sum"].toFixed(2)
            var annex_number = i+1
            self.contract["annex_name_list"] += "Приложение № "+annex_number+" – Спецификация № "+annex_number+", "
            self.contract["annex_name_row"] += "Спецификации № "+annex_number+", "
            self.contract["annex_number_list"] += "№ "+annex_number+", "
          });

          this.contract["annex_name_row"] = this.contract["annex_name_row"].substring(0, this.contract["annex_name_row"].length-2)
          this.contract["annex_number_list"] = this.contract["annex_number_list"].substring(0, this.contract["annex_name_row"].length-2)
          this.contract["annex_name_list"] = this.contract["annex_name_list"].substring(0, this.contract["annex_name_list"].length-2)
          
          var rubles = require('rubles').rubles;
          this.contract["total_sum"] = this.contract["total_sum"].toFixed(2)
          this.contract["text_sum"] = rubles(this.contract["total_sum"])
          
          var date_split = this.contract['date'].split('-')
          var day = date_split[2]
          var month = date_split[1]
          var year = date_split[0]
          let months_names=["Января", "Февраля", "Марта", "Апреля", "Мая", "Июня", "Июля", "Августа", "Сентября", "Октября", "Ноября", "Декабря"]

          this.contract['date'] = day+' '+months_names[Number(month)-1]+' '+year+'г.'
          this.document_number = this.contract.number;
         

          this.get_act_date()
          this.loading = false;
        }
      }).catch(function (error) {
        if(location.pathname.split('/')[2] > 0){
          location.reload();
        }
      });
    },
    getCookie(name) {
      var matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
      ));
      return matches ? decodeURIComponent(matches[1]) : undefined;
    },
    get_current_user(){
      axios.defaults.headers.get['x-access-token'] = this.token
      axios.get('https://c.seldon.org/user/current').then((response) => {
         this.user = response.data['user'] 
      }).catch(function (error) {
        document.location.href = 'https://lk.seldon.org/';
      });
    },
    set_act_date(){
      if(this.act_date.length > 10){
        axios.defaults.headers.post['x-access-token'] = this.token
        axios.post('https://c.seldon.org/tenma/act/date/'+this.invoice_id, {
          'date': this.act_date,
        }).then((response) => {
         if(response.data['code'] == 200){
            this.get_act_date();
         } 
        }).catch(function (error) {
          console.log(error)
       });

      }
    },
    get_act_date(){
      axios.defaults.headers.get['x-access-token'] = this.token
      axios.get('https://c.seldon.org/tenma/act/date/'+this.invoice_id).then((response) => {
         this.act_date = response.data['date']
         if(!this.act_date){
            this.is_date_edit = true
         } else {
          this.edit_date_access = false
         }
      })
    },
  },
    mounted(){
      this.token = this.getCookie('t');
      this.get_current_user();

    },
}
</script>

<style>
#app {
  font-family:  Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
